//
//
//
//
//
//
//
//
//


export default {
  props: [],

  computed: {

  },
  watch: {

  },
  components: {

  },
  data() {
    return {


      destination: '118-W-North-ST-KINSTON-NC-28501',
      address: '',

     
    }
  },
  mounted() {



  },
  methods: {
    
    getDirections() {

 
      let url = `https://www.google.com/maps/dir/${this.address}/${this.destination}`

      window.open(url.replace(' ', '-'), '_blank');
  

    }

  }
}




// WEBPACK FOOTER //
// ./scripts/components/Directions.vue